export const MAX_POI_IMAGES = 10
export const MAX_IMAGE_SIZE_MB = 20
export const MAX_AUDIO_SIZE_MB = 20

export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const
export const ACCEPTED_AUDIO_TYPES = ['audio/mpeg', 'audio/wav', 'audio/x-m4a', 'audio/mp4'] as const

export const IMAGE_RESIZE_TARGETS = {
  thumbnail: 150,
  medium: 600,
  large: 1200,
} as const

export interface TtsVoice {
  id: string
  label: string
  lang: string
}

export const TTS_VOICES: TtsVoice[] = [
  { id: 'vi-female-1', label: 'Vietnamese Female', lang: 'vi' },
  { id: 'vi-male-1', label: 'Vietnamese Male', lang: 'vi' },
  { id: 'en-female-1', label: 'English Female', lang: 'en' },
  { id: 'en-male-1', label: 'English Male', lang: 'en' },
]
